import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';

import {
  CreateUser,
  PagedResultDto,
  UpdateUserDto,
  User,
  UserChangePassword,
  UserDto,
  UserPayload
} from '../models';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private http = inject(HttpClient);
  private readonly apiUrl = '/api/Users';

  getAll(payload?: Partial<UserPayload>): Observable<PagedResultDto<User>> {
    const params = HttpHelper.toHttpParams(payload ?? {});
    return this.http.get<PagedResultDto<User>>(`${this.apiUrl}`, { params });
  }

  get(id: string): Observable<User> {
    return this.http.get<User>(`${this.apiUrl}/${id}`);
  }

  create(payload: CreateUser): Observable<User> {
    return this.http.post<User>(`${this.apiUrl}`, payload);
  }

  update(id: string, payload: UpdateUserDto): Observable<User> {
    return this.http.put<User>(`${this.apiUrl}/${id}`, payload);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  checkEmail(email: string): Observable<boolean> {
    const params = HttpHelper.toHttpParams({ email });
    return this.http.get<boolean>(`${this.apiUrl}`, { params });
  }

  changePassword(
    id: string,
    payload: UserChangePassword
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.apiUrl}/${id}/change-password`,
      payload
    );
  }

  getMe(): Observable<UserDto> {
    return this.http.get<UserDto>(`${this.apiUrl}/me`);
  }
}
